import { render, staticRenderFns } from "./SelectPlanCard.vue?vue&type=template&id=b1b96358&"
import script from "./SelectPlanCard.vue?vue&type=script&lang=js&"
export * from "./SelectPlanCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports